import React from 'react';

import { RectangleSkeleton } from '@sm360/widget-commons-general';
import { LocaleService } from '@sm360/widget-commons-core-services';
import 'commons-vehicle/Vehicle/components/Payment/Financing/Financing.scss';

const FinancingSkeleton = () => (
    <div className="financing-section tile-payment-info">
        <div className="tile-frequency is-bold">
            <RectangleSkeleton width={100} height={15} />
            <span>
                / <RectangleSkeleton width={20} height={15} /> {LocaleService.t('TERMS.MONTH')}
            </span>
        </div>
        <div className="tile-payment">
            <div className="tile-payment-amount is-bold is-price">
                <RectangleSkeleton width={70} height={25} />
                <sup>$</sup>
                <span>
                    /<RectangleSkeleton width={35} height={15} />
                </span>
                <div className="tile-term">
                    <span className="is-small is-light">
                        <RectangleSkeleton width={150} height={10} />
                    </span>
                </div>
            </div>

            <div className="tile-payment-rate">
                <RectangleSkeleton width={45} height={25} />
                <sup>%</sup>
                <span className="frequency-highlight">
                    {'/ '} <RectangleSkeleton width={20} height={15} /> {LocaleService.t('TERMS.MONTH')}
                </span>
            </div>
            <div className="tile-payment-detail small">
                <div className="tile-payment-detail-wrapper">
                    <span className="tile-payment-detail-note">{LocaleService.t('DOWN_PAYMENTS.TOTAL_CREDIT')}</span>
                    <RectangleSkeleton width={60} height={15} />{' '}
                </div>
            </div>

            <div className="tile-payment-detail cashdown">
                <div className="tile-payment-detail-wrapper">
                    <span className="tile-payment-detail-note">{LocaleService.t('DOWN_PAYMENTS.CASH_DOWN_LABEL')}</span>
                    <div>
                        <RectangleSkeleton width={100} height={15} /> {' $'}
                    </div>
                </div>
            </div>
            <div className="tile-payment-detail">
                <div className="tile-payment-detail-wrapper">
                    <span className="tile-payment-detail-note">{LocaleService.t('DOWN_PAYMENTS.SELLING_PRICE')}</span>
                    <div>
                        <RectangleSkeleton width={100} height={15} /> {' $'}
                    </div>
                </div>
            </div>
        </div>
    </div>
);
FinancingSkeleton.displayName = 'FinancingSkeleton';
export default FinancingSkeleton;
